// eslint-disable-next-line no-restricted-imports
import { SvgIcon, type SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

export interface ShieldIconProps extends SvgIconProps {
  /**
   * Variant of the shield icon
   * - "filled": White fill with blue gradient stroke (for colored backgrounds)
   * - "outlined": Grey outlined version (for light backgrounds)
   * @default "filled"
   */
  variant?: "filled" | "outlined";
}

export const ShieldIcon = forwardRef<SVGSVGElement, ShieldIconProps>((props, ref) => {
  const { variant = "filled", ...rest } = props;

  if (variant === "outlined") {
    return (
      <SvgIcon ref={ref} viewBox="0 0 23 28" {...rest}>
        <path
          d="M22.7852 5.12695V12.4648C22.7852 19.2713 17.966 25.6331 11.5 27.2002C5.03404 25.6331 0.214844 19.2713 0.214844 12.4648V5.12695L11.5 0.234375L22.7852 5.12695ZM11.4141 2.53223L2.46973 6.40918L2.34082 6.46582V13.9268H11.2852V25.1318L11.5625 25.0488C16.4073 23.5876 19.9704 18.9347 20.6572 13.7275L20.6895 13.4844H11.7148V2.40234L11.4141 2.53223Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.42996"
        />
      </SvgIcon>
    );
  }

  return (
    <SvgIcon ref={ref} viewBox="0 0 23 28" {...rest}>
      <path
        d="M22.7852 5.12695V12.4648C22.7852 19.2713 17.966 25.6331 11.5 27.2002C5.03404 25.6331 0.214844 19.2713 0.214844 12.4648V5.12695L11.5 0.234375L22.7852 5.12695ZM11.4141 2.53223L2.46973 6.40918L2.34082 6.46582V13.9268H11.2852V25.1318L11.5625 25.0488C16.4073 23.5876 19.9704 18.9347 20.6572 13.7275L20.6895 13.4844H11.7148V2.40234L11.4141 2.53223Z"
        fill="url(#shieldGradientFill)"
        stroke="url(#shieldGradientStroke)"
        strokeWidth="0.42996"
      />
      <defs>
        <linearGradient
          id="shieldGradientFill"
          x1="-2.65732"
          y1="-0.0991993"
          x2="31.0006"
          y2="25.6111"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="shieldGradientStroke"
          x1="-2.65732"
          y1="-0.0991993"
          x2="31.0006"
          y2="25.6111"
          gradientUnits="userSpaceOnUse"
        >
          {/* eslint-disable-next-line no-restricted-syntax -- SVG gradient colors from Figma design */}
          <stop stopColor="#4B6AA6" />
          {/* eslint-disable-next-line no-restricted-syntax -- SVG gradient colors from Figma design */}
          <stop offset="1" stopColor="#909CAE" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
});

ShieldIcon.displayName = "ShieldIcon";
